import React, { createContext, FunctionComponent, ReactNode, useContext, useState } from 'react'
import { NotificationError } from '../../model'

export interface SummaryNotificationContextProps {
  notification?: NotificationError
  setNotification: (notification: NotificationError | undefined) => void
  clicked: boolean
  setClicked: (clicked: boolean) => void
}

export const SummaryNotificationContext = createContext<SummaryNotificationContextProps>({
  notification: undefined,
  setNotification: () => {},
  clicked: false,
  setClicked: () => {},
})

export const useSummaryNotification = (): SummaryNotificationContextProps => {
  return useContext(SummaryNotificationContext)
}

export const SummaryNotificationProvider: FunctionComponent<{ children: ReactNode }> = ({ children }) => {
  const [notification, setNotification] = useState<NotificationError>()
  const [clicked, setClicked] = useState(false)

  return <SummaryNotificationContext.Provider value={{ notification, setNotification, setClicked, clicked }}>{children}</SummaryNotificationContext.Provider>
}
